import { useTranslation } from '../hooks/useTranslation';
import type { DispatchResult } from '../hooks/useBotFanOut';
import styles from './DispatchResultPill.module.css';

export default function DispatchResultPill(props: { result: DispatchResult }) {
    const { t } = useTranslation();
    const label = () => {
        if (props.result.state === 'pending') return t('MULTI_RESULT_PENDING');
        if (props.result.state === 'ok') return t('MULTI_RESULT_OK');
        return props.result.msg ?? t('MULTI_RESULT_ERROR');
    };

    return (
        <span class={`${styles.pill} ${styles[props.result.state]}`} title={props.result.msg}>
            {label()}
        </span>
    );
}
